import type { IEntityModel } from './base'

export enum ProductCapability {
  HRVGraph = 'hrv_graph',
  ActigraphyGraph = 'actigraphy_graph',
  ParticipantLimit20 = 'participant_limit_20',
}

export enum ProductPlan {
  Basic = 'basic',
  Advanced = 'advanced',
}

export const productCapabilityDescriptionMap: Record<
  ProductCapability,
  string
> = {
  hrv_graph: 'Can show HRV graph in visualizer',
  actigraphy_graph: 'Can show Actigraphy graph in visualizer',
  participant_limit_20: 'Can increase participant limit to 20',
}
export interface IProduct extends IEntityModel {
  name: string
  price: string
  plan: ProductPlan | null
  capabilityList: ProductCapability[]
}
